import { simplePath } from "../utils.js";
const GET_ORGANIZATION_BY_NAME_PATH = '/v2/organization/:organization';
function get_organization_by_name_path(params) {
    return simplePath(GET_ORGANIZATION_BY_NAME_PATH, params);
}
export { GET_ORGANIZATION_BY_NAME_PATH, get_organization_by_name_path };
